import React from 'react';

export const createPageReader = (domainType, pageKey) => {
  const TemplatePageReader = ({ template, sections, renderSection, educationData }) => (
    <>
      {sections.map((section, index) => renderSection(section, index, template, educationData))}
    </>
  );

  TemplatePageReader.displayName = `${domainType}${pageKey.charAt(0).toUpperCase()}${pageKey.slice(1)}Reader`;
  TemplatePageReader.readerDomain = domainType;
  TemplatePageReader.readerPageKey = pageKey;

  return TemplatePageReader;
};
